export enum PrintEvents {
  BROWSER = 'BrowserPrintCompleted',
  ZBP = 'ZBPPrintCompleted',
  HubPrintTimeout = 'HubPrintTimeout',
  HubLocalServer = 'HubLocalServer',
  HubPrintLabelPhase1 = 'HubPrintLabelPhase1',
  HubPrintLabelPhase2 = 'HubPrintLabelPhase2',
}
